import fetchMock from 'fetch-mock';

/**
 * This class is used to mock fetch requests.
 * If you need to mock fetch requests just add the url the response and if necessary its headers.
 * @constructor
 */
export default class MockFetchHttp {
  execute() {
    let urlsAndResponse = this.getFetchUrls();
    urlsAndResponse.forEach((record) => {
      const { response, header, url } = record;
      if (header) {
        fetchMock.mock(url, response, header);
      } else {
        fetchMock.mock(url, response);
      }
    });
  }

  getFetchUrls() {
    return [
      {
        url: /^.*?localhost:4000\/api\/service_items\/G11\?user_id=?.*$/,
        response: {
          acquisition_type: "Parcel",
          gbg_id: "G774411",
          market_name: "Philadelphia",
          parcel_id: 129,
          processed_by: "4a02ce07-bdb2-450a-99c2-65bdab2d680b",
          rma: {
              expected_number_of_items: 2,
              number_of_items_processed: 6,
              partner_name: "Stokke",
              rma_items: [
                  {
                      brand: "Stokke",
                      gbg_product_id: "c3b18dc0-1852-4cd8-8e33-61fe5ea30c85",
                      model: "Tripp Trapp Complete High Chair",
                      processed_at: "2024-02-22T11:55:54Z",
                      processing_status: "PROCESSED",
                      rma_item_id: 185,
                      rma_number: "testNoMatchQuantities1",
                      sku: "10000550.1.897",
                      vendor_metadata: {
                          articleImageUrl: "https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                          articleName: "Tripp Trapp® Chair",
                          articleNo: "528920",
                          articleUrl: "https://www.stokke.com/USA/en-us/570603.html",
                          compensationMethod: "refund",
                          prettyReturnReason: "Quality Issues",
                          price: 238.82,
                          problemDescription: null,
                          quantity: 1,
                          returnImages: null,
                          returnReason: "04"
                      }
                  },
                  {
                      brand: "Stokke",
                      gbg_product_id: "adb062c2-fc66-466e-a0a9-b3dcc3474b32",
                      model: "Tripp Trapp Classic Cushion",
                      processed_at: "2024-02-22T12:00:31Z",
                      processing_status: "PROCESSED",
                      rma_item_id: 186,
                      rma_number: "testNoMatchQuantities1",
                      sku: "10000550.1.900",
                      vendor_metadata: {
                          articleImageUrl: "https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/TrippTrappBS_Natural_ClassCush_IntoTheDeep_Tray_1-5_US_eCom.jpg",
                          articleName: "Tripp Trapp® Classic Cushion",
                          articleNo: "146068",
                          articleUrl: "https://www.stokke.com/USA/en-us/643200.html",
                          compensationMethod: "refund",
                          prettyReturnReason: "Change of mind or other",
                          price: 358.66,
                          problemDescription: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.",
                          quantity: 1,
                          returnImages: null,
                          returnReason: "05"
                      }
                  },
                  {
                      brand: "Stokke",
                      gbg_product_id: "c3b18dc0-1852-4cd8-8e33-61fe5ea30c85",
                      model: "Tripp Trapp Complete High Chair",
                      processed_at: "2024-02-22T11:57:35Z",
                      processing_status: "ADDITIONAL_ITEM_NOT_FOUND",
                      rma_item_id: 187,
                      rma_number: "testNoMatchQuantities1",
                      sku: "10000550.1.898",
                      vendor_metadata: {
                          articleImageUrl: "",
                          articleName: "Tripp Trapp® Chair",
                          articleNo: "528920",
                          articleUrl: "",
                          compensationMethod: "",
                          prettyReturnReason: "",
                          price: 0.0,
                          problemDescription: "Unexpected: 1+ Item returned does not match any in the manifest with SKU 10000550.1.898",
                          quantity: 1,
                          returnImages: null,
                          returnReason: ""
                      }
                  },
                  {
                      brand: "Stokke",
                      gbg_product_id: "c3b18dc0-1852-4cd8-8e33-61fe5ea30c85",
                      model: "Tripp Trapp Complete High Chair",
                      processed_at: "2024-02-22T11:58:51Z",
                      processing_status: "ADDITIONAL_ITEM_NOT_FOUND",
                      rma_item_id: 188,
                      rma_number: "testNoMatchQuantities1",
                      sku: "10000550.1.899",
                      vendor_metadata: {
                          articleImageUrl: "",
                          articleName: "Tripp Trapp® Chair",
                          articleNo: "528920",
                          articleUrl: "",
                          compensationMethod: "",
                          prettyReturnReason: "",
                          price: 0.0,
                          problemDescription: "Unexpected: 1+ Item returned does not match any in the manifest with SKU 10000550.1.899",
                          quantity: 1,
                          returnImages: null,
                          returnReason: ""
                      }
                  },
                  {
                      brand: "Stokke",
                      gbg_product_id: "adb062c2-fc66-466e-a0a9-b3dcc3474b32",
                      model: "Tripp Trapp Classic Cushion",
                      processed_at: "2024-02-22T12:02:02Z",
                      processing_status: "ADDITIONAL_ITEM_NOT_FOUND",
                      rma_item_id: 189,
                      rma_number: "testNoMatchQuantities1",
                      sku: "10000550.1.901",
                      vendor_metadata: {
                          articleImageUrl: "",
                          articleName: "Tripp Trapp® Classic Cushion",
                          articleNo: "146068",
                          articleUrl: "",
                          compensationMethod: "",
                          prettyReturnReason: "",
                          price: 0.0,
                          problemDescription: "Unexpected: 1+ Item returned does not match any in the manifest with SKU 10000550.1.901",
                          quantity: 1,
                          returnImages: null,
                          returnReason: ""
                      }
                  },
                  {
                      brand: "Stokke",
                      gbg_product_id: "adb062c2-fc66-466e-a0a9-b3dcc3474b32",
                      model: "Tripp Trapp Classic Cushion",
                      processed_at: "2024-02-22T12:03:27Z",
                      processing_status: "ADDITIONAL_ITEM_NOT_FOUND",
                      rma_item_id: 190,
                      rma_number: "testNoMatchQuantities1",
                      sku: "10000550.1.902",
                      vendor_metadata: {
                          articleImageUrl: "",
                          articleName: "Tripp Trapp® Classic Cushion",
                          articleNo: "146068",
                          articleUrl: "",
                          compensationMethod: "",
                          prettyReturnReason: "",
                          price: 0.0,
                          problemDescription: "Unexpected: 1+ Item returned does not match any in the manifest with SKU 10000550.1.902",
                          quantity: 1,
                          returnImages: null,
                          returnReason: ""
                      }
                  }
              ],
              rma_number: "testNoMatchQuantities1",
              status: "PROCESSED"
          },
          scan_time: "2024-02-22T11:52:16Z",
           service_id: '5ac9683b-6955-4a55-9d6f-78f3ea18175a',
          tracking_number: "testNoMatchQuantities1"
      }
      },
      {
        url: /^.*?localhost:4000\/api\/service_items\/G1\?user_id=?.*$/,
        response: {
          acquisition_type: 'Parcel',
          gbg_id: 'G1231231234',
          market_name: 'Denver',
          parcel_id: 19,
          rma: {
            expected_number_of_items: 2,
            number_of_items_processed: 0,
            partner_name: 'Stokke',
            rma_items: [
              {
                brand: 'Stokke',
                gbg_product_id: '04795fc2-3598-4f44-ade5-7c3098a9815f',
                model: 'Seat Cushion',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 10,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  "price":238.82,
                  "quantity":1,
                  "articleNo":570603,
                  "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                  "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                  "returnImages":null,
                  "returnReason":"04",
                  "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                  "compensationMethod":"refund",
                  "prettyReturnReason":"Quality Issues",
                  "problemDescription":null
                }
              },
              {
                brand: 'Stokke',
                gbg_product_id: '71056021-a5db-44ea-b8af-b4b09f1217ad',
                model: 'Tripp Trapp High Chair',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 11,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  "price":238.82,
                  "quantity":1,
                  "articleNo":570603,
                  "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                  "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                  "returnImages":null,
                  "returnReason":"04",
                  "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                  "compensationMethod":"refund",
                  "prettyReturnReason":"Quality Issues",
                  "problemDescription":null
                }
              },
              {
                brand: 'Stokke',
                gbg_product_id: '0adf4031-9ea9-4f0a-972c-ec3b7f37df47',
                model: 'Car Seat Adapter Multi',
                processed_at: null,
                processing_status: 'PROCESSED',
                rma_item_id: 12,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  "price":238.82,
                  "quantity":1,
                  "articleNo":570603,
                  "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                  "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                  "returnImages":null,
                  "returnReason":"04",
                  "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                  "compensationMethod":"refund",
                  "prettyReturnReason":"Quality Issues",
                  "problemDescription":null
                }
              },
              {
                brand: 'Stokke',
                gbg_product_id: '59fec78c-5c99-4883-80f4-148c5bee6166',
                model: 'Not matching',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 13,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  "price":238.82,
                  "quantity":1,
                  "articleNo":570603,
                  "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                  "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                  "returnImages":null,
                  "returnReason":"04",
                  "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                  "compensationMethod":"refund",
                  "prettyReturnReason":"Quality Issues",
                  "problemDescription":null
                }
              },
              {
                brand: 'Stokke',
                gbg_product_id: '20d757cd-1c91-463f-a945-472a36a08466',
                model: 'Sleepi Crib Original',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 14,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                    "price":238.82,
                    "quantity":1,
                    "articleNo":570603,
                    "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                    "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                    "returnImages":null,
                    "returnReason":"04",
                    "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                    "compensationMethod":"refund",
                    "prettyReturnReason":"Quality Issues",
                    "problemDescription":null
                }
              },
              {
                brand: 'Stokke',
                gbg_product_id: null,
                model: 'Not found 1',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 15,
                rma_number: '0060007182',
                sku: null,
                vendor_metadata: {
                    "price":238.82,
                    "quantity":1,
                    "articleNo":570603,
                    "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                    "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                    "returnImages":null,
                    "returnReason":"04",
                    "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                    "compensationMethod":"refund",
                    "prettyReturnReason":"Quality Issues",
                    "problemDescription":null
                }
              },
              {
                brand: 'Stokke',
                gbg_product_id: null,
                model: 'Not found 2',
                processed_at: null,
                processing_status: 'PROCESSED',
                rma_item_id: 16,
                rma_number: '0060007182',
                sku: null,
                vendor_metadata: {
                    "price":238.82,
                    "quantity":1,
                    "articleNo":570603,
                    "articleUrl":"https://www.stokke.com/USA/en-us/570603.html",
                    "articleName":"Travel bundle BedBox™ + Crew BackPack™ Pink/Pink",
                    "returnImages":null,
                    "returnReason":"04",
                    "articleImageUrl":"https://www.stokke.com/on/demandware.static/-/Sites-stokke-master-catalog/default/v0595f7a8926008c95c7e633b5f0fe65eb6293980/images/inriverimages/mainview/JetKids_BedBoxV3_BackPack_PinkLemonade_Stickers_200924_eCom.jpg",
                    "compensationMethod":"refund",
                    "prettyReturnReason":"Quality Issues",
                    "problemDescription":null
                }
              }
            ],
            rma_number: '0060007181',
            status: 'RMA_CREATED'
          },
          scan_time: '2023-02-07T16:32:49Z',
          service_id: '5ac9683b-6955-4a55-9d6f-78f3ea18175a',
          tracking_number: '0060007181'
        }
      },
      {
        url: /^.*?localhost:4000\/api\/service_items\/G2\?user_id=?.*$/,
        response: {
          acquisition_type: 'Parcel',
          gbg_id: 'G1231231234',
          market_name: 'Denver',
          parcel_id: 19,
          rma: {
            expected_number_of_items: 2,
            number_of_items_processed: 0,
            partner_name: '4moms',
            rma_items: [
              {
                brand: '4moms',
                gbg_product_id: '340dde04-ad00-4391-ab05-f7f0c0070ace',
                model: 'MamaRoo Sleep Bassinet',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 10,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep - NA - Birch',
                  matnr: '000000000002000754',
                  posnr: 10,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              },
              {
                brand: '4moms',
                gbg_product_id: '340dde04-ad00-4391-ab05-f7f0c0070ace',
                model: 'MamaRoo Sleep Bassinet',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 11,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep - NA - Birch',
                  matnr: '000000000002000754',
                  posnr: 10,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              },
              {
                brand: '4moms',
                gbg_product_id: '49fec78c-5c99-4883-80f4-148c5bee6166',
                model: '6/1/2022',
                processed_at: null,
                processing_status: 'PROCESSED',
                rma_item_id: 12,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep-Sheet-NA - WHT/Crosshatch',
                  matnr: '000000000002000913',
                  posnr: 20,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              },
              {
                brand: '4moms',
                gbg_product_id: '59fec78c-5c99-4883-80f4-148c5bee6166',
                model: 'Not matching',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 13,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep-Sheet-NA - WHT/Crosshatch',
                  matnr: '000000000002000913',
                  posnr: 20,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              },
              {
                brand: '4moms',
                gbg_product_id: '59fec78c-5c99-4883-80f4-148c5bee6166',
                model: 'Not matching 2',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 14,
                rma_number: '0060007181',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep-Sheet-NA - WHT/Crosshatch',
                  matnr: '000000000002000913',
                  posnr: 20,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              },
              {
                brand: '4moms',
                gbg_product_id: null,
                model: 'Not found 1',
                processed_at: null,
                processing_status: 'RMA_CREATED',
                rma_item_id: 15,
                rma_number: '0060007182',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep-Sheet-NA - green -  WHT/Crosshatch',
                  matnr: '000000000002000913',
                  posnr: 20,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              },
              {
                brand: '4moms',
                gbg_product_id: null,
                model: 'Not found 2',
                processed_at: null,
                processing_status: 'PROCESSED',
                rma_item_id: 16,
                rma_number: '0060007182',
                sku: null,
                vendor_metadata: {
                  arktx: 'mamaRoo sleep-Sheet-NA - green -  WHT/Crosshatch',
                  matnr: '000000000002000913',
                  posnr: 20,
                  zieme: 'EA',
                  zmeng: 1.0
                }
              }
            ],
            rma_number: '0060007181',
            status: 'RMA_CREATED'
          },
          scan_time: '2023-02-07T16:32:49Z',
          service_id: '5ac9683b-6955-4a55-9d6f-78f3ea18175a',
          tracking_number: '0060007181'
        }
      },
      {
        url: /^.*?localhost:4000\/api\/service_items\/G1234\?user_id=?.*$/,
        response: {
          acquisition_type: 'Parcel',
          gbg_id: 'G1231231234',
          market_name: 'Denver',
          parcel_id: 19,
          processed_by: null,
          rma: null,
          scan_time: '2023-02-07T16:32:49Z',
          service_id: 'd4531051-6852-4e40-b456-492910e98816',
          tracking_number: '0060007181'
        }
      },
      {
        url: /^.*?localhost:3037\/v5\/calculate-recommended-price.*$/,
        response: { data: {
            calculated_price: 80.99,
            rule: "get_products_with_active_inventory",
              values: [{
                "Price": 80.99,
                "id": "6ee6026d-5caf-4b2d-83f4-98e3a2f24ab3"
              }]
            }
          }
      }
    ];
  }
}
